// PSO Release 07: cached theme-owned sizing controller; behavior retained.
(() => {
const psoConfig = JSON.parse(document.currentScript.dataset.psoConfig);
/* =================== saadaa Kiwi → Enrich overlay swatches + chips + modal =================== */
/* CHANGE LOG BY DEVESH 2026-09-14: readCache() returns only the chart inlined with the page — no localStorage read — so a chart deleted or reassigned in Lister stops painting from a 7-day cache. */
(function(){
  // Combo templates render no sticky bar / size overlay but still need the Kiwi modal:
  // a detached stub keeps every overlay query harmless (empty) instead of bailing out.
  const hasOverlay = !!document.getElementById('saadaa-size-overlay');
  const overlay = document.getElementById('saadaa-size-overlay') || document.createElement('div');

  const SIZE_LOOKUP = ['XXS','XS','S','M','L','XL','2XL','3XL','4XL','5XL','6XL'];

  const CACHE_KEY = 'saadaaKiwiMap:' + (psoConfig.handle || location.pathname);
  const KIWI_CHART_ID = String(psoConfig.chartId || '').trim();   // 2026-09-12: ids can carry a trailing newline
  const CACHE_KEY_C = KIWI_CHART_ID ? ('saadaaKiwiC:' + KIWI_CHART_ID) : null;
  const CACHE_TTL = 1000 * 60 * 60 * 24 * 7;

  const readoutEl = overlay.querySelector('.saadaa-inline-size-meta');

  const kscBackdrop = document.getElementById('saadaa-ksc-backdrop');
  const kscModal    = document.getElementById('saadaa-ksc-modal');
  const kscTable    = kscModal.querySelector('.saadaa-ksc-table');
  const kscTitle    = document.getElementById('saadaa-ksc-title');
  const kscAddBtn   = document.getElementById('saadaa-ksc-add');
  const unitToggle  = document.getElementById('saadaa-ksc-unit-toggle');
  // no size variants to add from the modal on combo pages — chart is reference only
  if (!hasOverlay && kscAddBtn) kscAddBtn.closest('.saadaa-ksc-foot')?.setAttribute('hidden', '');

  const productTitle = psoConfig.title;
  const variantInputMain = document.querySelector('form[action^="/cart/add"] [name="id"]');

  let currentUnit = 'in'; // State for CM vs INCH toggle

  /* map size -> variant id using overlay buttons */
  const sizeToVariant = {};
  const sizeOOS = {};
  overlay.querySelectorAll('.saadaa-variant-btn').forEach(b=>{
    const sz = (b.getAttribute('data-value') || b.textContent || '').trim().toUpperCase();
    sizeToVariant[sz] = b.getAttribute('data-variant-id') || null;
    sizeOOS[sz] = b.classList.contains('saadaa-oos') || b.disabled;
  });

  /* ---------- utils ---------- */
  const norm  = t => (t||'').replace(/\s+/g,' ').trim();
  const upper = t => norm(t).toUpperCase();
  const pickFirstHeader = (headers, patterns) => { for (const rx of patterns){ const h = headers.find(H => rx.test(H)); if (h) return h; } return null; };
  /* 2026-09-13: prefer the chart inlined with the page over anything cached or remote. */
  const inlineChart = () => { const t = psoConfig.chartTable; return (t && t.headers && t.rows && Object.keys(t.rows).length) ? { ts: Date.now(), headers: t.headers, rows: t.rows } : null; };
  const readCache = () => inlineChart();   /* 2026-09-14: the page is the only source; the localStorage read was a Kiwi-latency workaround and painted deleted charts */
  const writeCache = (payload) => { try{ const v=JSON.stringify({ts:Date.now(), ...payload}); localStorage.setItem(CACHE_KEY, v); if (CACHE_KEY_C) localStorage.setItem(CACHE_KEY_C, v); }catch(_){ } };

  function findKiwiTables(){
    const roots = [
      document.querySelector('#KiwiSizingModal'),
      document.querySelector('.kiwiSizingModal'),
      ...document.querySelectorAll('[class*="Kiwi"][class*="Modal"], [class*="kiwi"][class*="modal"]'),
      document
    ].filter(Boolean);
    const tables = [];
    for (const r of roots){
      tables.push(...r.querySelectorAll('table'));
      if (tables.length) break;
    }
    return Array.from(new Set(tables));
  }
  function getHeaderCells(t){
    const thead = t.querySelector('thead');
    if (thead) return Array.from(thead.querySelectorAll('th,td')).map(th=>upper(th.textContent));
    const first = t.querySelector('tr');
    if (!first) return [];
    return Array.from(first.children).map(td=>upper(td.textContent));
  }
  function buildRowsFromTable(t){
    const headersRaw = getHeaderCells(t);
    if (headersRaw.length < 2) return {headers:[], rows:{}};
    const headers = headersRaw.map(h=>h.replace(/\s+/g,' ').trim());

    let sizeCol = headers.findIndex(h=>/^SIZE$/.test(h));
    if (sizeCol < 0) sizeCol = 0;

    const bodyRows = t.querySelectorAll('tbody tr');
    const rowsEls = bodyRows.length ? bodyRows : t.querySelectorAll('tr');

    const rowsMap = {};
    rowsEls.forEach((tr, idx)=>{
      if (!bodyRows.length && idx===0) return;
      const cells = Array.from(tr.children).map(td=>norm(td.textContent));
      if (!cells.length) return;

      const sizeKey = upper(cells[sizeCol] || '');
      if (!SIZE_LOOKUP.includes(sizeKey)) return;

      const rec = {};
      headers.forEach((h,i)=>{ if (i!==sizeCol){ const v=cells[i] || ''; if (v) rec[h]=v; }});
      rowsMap[sizeKey] = rec;
    });

    return {headers, rows: rowsMap};
  }
  function chooseBestPayload(){
    const tables = findKiwiTables();
    let best = {headers:[], rows:{}}, score = -1;
    for (const t of tables){
      const p = buildRowsFromTable(t);
      const s = Object.keys(p.rows).length;
      if (s > score){ score = s; best = p; }
    }
    return best;
  }
  async function ensureKiwiLoaded(){
    if (findKiwiTables().length) return;
    (document.querySelector('#KiwiSizingChart') || document.querySelector('#saadaaKiwiSizingChartOverlay'))?.click();
    await new Promise(r=>setTimeout(r, 500));
    document.querySelectorAll('.ks-modal, .kiwiSizingModal, [id*="Kiwi"][class*="Modal"]').forEach(el=>{ el.style.display='none'; });
  }

  /* ---------- Enrich overlay buttons + dataset for chips ---------- */
    function applyToOverlay(payload) {
        const { rows, headers } = payload;
        const btns = overlay.querySelectorAll('.saadaa-variant-btn');

        let headerPriority = [/\bCHEST\b/, /\bBUST\b/, /\bWAIST\b/, /\bHIPS?\b/, /\b(LENGTH|INSEAM)\b/];
        if (psoConfig.isBottom) {
        headerPriority = [/\bWAIST\b/, /\bHIPS?\b/, /\b(LENGTH|INSEAM)\b/];
        } else if (psoConfig.isTop && psoConfig.isWomen) {
        headerPriority = [/\bBUST\b/, /\bCHEST\b/, /\bWAIST\b/, /\bHIPS?\b/, /\b(LENGTH|INSEAM)\b/];
        } else if (psoConfig.isTop && psoConfig.isMen) {
        headerPriority = [/\bCHEST\b/, /\bWAIST\b/, /\bHIPS?\b/, /\b(LENGTH|INSEAM)\b/];
        } // pso Liquid branch end

        const firstDataHeader = pickFirstHeader(headers, headerPriority) || headers.find((h, idx) => idx !== 0) || '';

    btns.forEach(btn=>{
      const size = upper(btn.getAttribute('data-value') || btn.textContent);
      const row  = rows[size] || {};
      const val  = row[firstDataHeader] || '';

      const codeEl  = btn.querySelector('.saadaa-sz-code');
      const extraEl = btn.querySelector('.saadaa-sz-extra');
      if (codeEl) codeEl.textContent = size;
      if (extraEl) extraEl.textContent = val;
      else if (val){ btn.innerHTML = '<span class="saadaa-sz-code">'+size+'</span><span class="saadaa-sz-extra">'+val+'</span>'; }

      const bustKey  = pickFirstHeader(headers, [/\bBUST\b/, /\bCHEST\b/]);
      const waistKey = pickFirstHeader(headers, [/\bWAIST\b/]);
      const hipKey   = pickFirstHeader(headers, [/\bHIPS?\b/]);
      const lenKey   = pickFirstHeader(headers, [/\b(LENGTH|INSEAM)\b/]);

      if (bustKey)  { btn.dataset.saadaaBust    = row[bustKey]  || ''; btn.dataset.saadaaBustKey  = bustKey; }
      if (waistKey) { btn.dataset.saadaaWaist   = row[waistKey] || ''; btn.dataset.saadaaWaistKey = waistKey; }
      if (hipKey)   { btn.dataset.saadaaHip     = row[hipKey]   || ''; btn.dataset.saadaaHipKey   = hipKey; }
      if (lenKey)   { btn.dataset.saadaaLen     = row[lenKey]   || ''; btn.dataset.saadaaLenKey   = lenKey; }
    });
  }

  /* ---------- Chips rendering ---------- */
  function renderChipsFrom(btn){
    if (!readoutEl) return;
    const pill = (k,v) => (k && v) ? '<span class="saadaa-kv-pill"><span class="saadaa-kv-key">'+k+':</span> '+v+'</span>' : '';
    const html = [
      pill(btn.dataset.saadaaBustKey,  btn.dataset.saadaaBust),
      pill(btn.dataset.saadaaWaistKey, btn.dataset.saadaaWaist),
      pill(btn.dataset.saadaaHipKey,   btn.dataset.saadaaHip),
      pill(btn.dataset.saadaaLenKey,   btn.dataset.saadaaLen),
    ].filter(Boolean).join('');
    if (html){ readoutEl.innerHTML = html; readoutEl.hidden = false; }
    else { readoutEl.innerHTML = ''; readoutEl.hidden = true; }
  }

  /* ---------- Hydration flow ---------- */
  function hydrateOnce(){
    const cached = readCache();
    if (cached && Object.keys(cached.rows||{}).length){
      applyToOverlay(cached);
    } else {
      const payload = chooseBestPayload();
      if (Object.keys(payload.rows).length){
        writeCache(payload);
        applyToOverlay(payload);
      } else {
        ensureKiwiLoaded().then(()=>{
          const again = chooseBestPayload();
          if (Object.keys(again.rows).length){
            writeCache(again);
            applyToOverlay(again);
          }
        });
      }
    }
    const sel = overlay.querySelector('.saadaa-variant-btn.saadaa-selected');
    if (sel) renderChipsFrom(sel);
  }
  window.saadaaHydrateOverlayKiwi = hydrateOnce;
  setTimeout(function(){ try { hydrateOnce(); } catch(_){} }, 1400);   // idle prefetch: warm chart + measurements before first open

  // Update chips on overlay swatch click
  overlay.addEventListener('click', (e)=>{
    const btn = e.target.closest('.saadaa-variant-btn');
    if (!btn || btn.classList.contains('saadaa-oos') || btn.disabled) return;
    renderChipsFrom(btn);
  });

  if (variantInputMain){
    variantInputMain.addEventListener('change', function(){
      const btn = overlay.querySelector('.saadaa-variant-btn[data-variant-id="'+this.value+'"]');
      if (btn) renderChipsFrom(btn);
    });
  }

  /* ---------- IN/CM Toggle Logic ---------- */
  function updateTableUnits() {
    const cells = kscTable.querySelectorAll('.saadaa-val-cell');
    cells.forEach(td => {
      const baseVal = td.getAttribute('data-base-val');
      if (!baseVal) return;
      if (currentUnit === 'cm') {
        // Convert inches to cm using Math
        td.textContent = baseVal.replace(/\d+(\.\d+)?/g, match => {
          return (parseFloat(match) * 2.54).toFixed(1).replace(/\.0$/, '');
        });
      } else {
        // Revert to original text (inches)
        td.textContent = baseVal;
      }
    });
  }

  document.querySelectorAll('.saadaa-unit-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      if (this.classList.contains('active')) return;
      
      document.querySelectorAll('.saadaa-unit-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      currentUnit = this.getAttribute('data-unit');
      updateTableUnits();
    });
  });

  /* ---------- Namespaced Modal logic (renders from Kiwi tables) ---------- */
  function opensaadaaModal(){ 
    kscBackdrop.style.display='block'; 
    kscModal.style.display='block'; 
    document.body.classList.add('saadaa-modal-open'); 
    
    // Clear validation error on open
    const err = document.getElementById('saadaa-ksc-err');
    if (err) err.style.display = 'none';
  }
  
  function closesaadaaModal(){ 
    kscBackdrop.style.display='none'; 
    kscModal.style.display='none'; 
    document.body.classList.remove('saadaa-modal-open'); 
  }
  
  kscBackdrop.addEventListener('click', closesaadaaModal);
  
  // Bound to touchstart for immediate mobile reaction, and click to be safe
  const closeKscBtn = kscModal.querySelector('.saadaa-ksc-close');
  if(closeKscBtn) {
    closeKscBtn.addEventListener('click', closesaadaaModal);
    closeKscBtn.addEventListener('touchstart', closesaadaaModal, {passive: true});
  }

function rendersaadaaModal(payload) {
        kscTitle.textContent = productTitle || 'Size Chart';
        kscTable.innerHTML = '';

        if (!payload || !payload.rows || !Object.keys(payload.rows).length) {
            kscTable.innerHTML = '<tr><td style="padding:16px;">Size chart unavailable.</td></tr>';
            if (unitToggle) unitToggle.style.display = 'none';
            return;
        }

        const allHeaders = (payload.headers || []).map(h => (h || '').trim()).filter(h => h && upper(h) !== 'SIZE');
        let filtered = allHeaders.filter(h => Object.keys(payload.rows).some(sz => (payload.rows[sz][h] || '').trim().length > 0));

        // --- NEW: Dynamic Column Sorting ---
        let headerPriority = [/\bCHEST\b/i, /\bBUST\b/i, /\bWAIST\b/i, /\bHIPS?\b/i, /\b(LENGTH|INSEAM)\b/i];
        if (psoConfig.isBottom) {
          headerPriority = [/\bWAIST\b/i, /\bHIPS?\b/i, /\b(LENGTH|INSEAM)\b/i];
        } else if (psoConfig.isTop && psoConfig.isWomen) {
          headerPriority = [/\bBUST\b/i, /\bCHEST\b/i, /\bWAIST\b/i, /\bHIPS?\b/i, /\b(LENGTH|INSEAM)\b/i];
        } else if (psoConfig.isTop && psoConfig.isMen) {
          headerPriority = [/\bCHEST\b/i, /\bWAIST\b/i, /\bHIPS?\b/i, /\b(LENGTH|INSEAM)\b/i];
        } // pso Liquid branch end

        filtered.sort((a, b) => {
            const idxA = headerPriority.findIndex(rx => rx.test(a));
            const idxB = headerPriority.findIndex(rx => rx.test(b));
            // If a column isn't in our priority list, push it to the end (weight 999)
            const weightA = idxA === -1 ? 999 : idxA;
            const weightB = idxB === -1 ? 999 : idxB;
            return weightA - weightB;
        });
        // -----------------------------------

        if (unitToggle) {
            unitToggle.style.display = filtered.length > 0 ? 'flex' : 'none';
        }

        const thead = document.createElement('thead');
        const trh = document.createElement('tr');
        const thRadio = document.createElement('th'); thRadio.className = 'saadaa-ksc-radio'; trh.appendChild(thRadio);
        const thSize = document.createElement('th');
        thSize.textContent = 'SELECT SIZE';
        thSize.style.color = '#1155cc'; /* <-- Added color here */
        trh.appendChild(thSize);
        
        filtered.forEach(h => {
            const th = document.createElement('th');
            
            // --- NEW: Check for Length to rename header ---
            if (/\b(LENGTH|INSEAM)\b/i.test(h)) {
                th.textContent = 'GARMENT LENGTH';
            } else {
                th.textContent = 'IF YOUR ' + h + ' IS';
            }
            
            trh.appendChild(th);
        });
        thead.appendChild(trh); kscTable.appendChild(thead);

    const tbody = document.createElement('tbody');
    Object.keys(payload.rows).forEach(size=>{
      const rec = payload.rows[size] || {};
      const tr = document.createElement('tr');

      const tdR = document.createElement('td'); tdR.className='saadaa-ksc-radio';
      const input = document.createElement('input'); input.type='radio'; input.name='saadaaKscSize'; input.value=size; input.setAttribute('aria-label', size);
      tdR.appendChild(input); tr.appendChild(tdR);

      const tdSize = document.createElement('td'); 
      tdSize.textContent = size; 
      tdSize.style.color = '#1155cc'; /* <-- Added color here */
      tdSize.style.fontWeight = '700'; /* Optional: makes it bold so the light color is easier to read */
      tr.appendChild(tdSize);
      
      // Inject cells with custom attributes for CM/INCH calculation
      filtered.forEach(h=>{ 
        const td = document.createElement('td'); 
        td.className = 'saadaa-val-cell';
        td.setAttribute('data-base-val', rec[h] || '');
        td.textContent = rec[h] || ''; 
        td.style.textAlign='center'; 
        kscTable.style.color='#000'; 
        td.style.color='#000'; 
        tr.appendChild(td); 
      });

      const vid = (psoConfig.variants || []).find(v => (v.option1||'').toUpperCase() === size)?.id || null;
      const disabled = !vid || !!(overlay.querySelector('.saadaa-variant-btn[data-variant-id="'+vid+'"]')?.classList.contains('saadaa-oos'));
      if (disabled){ input.disabled = true; tr.setAttribute('aria-disabled','true'); }

      function selectRow(){
        if (input.disabled) return;
        kscTable.querySelectorAll('tbody tr').forEach(r=>r.classList.remove('selected','saadaa-selected'));
        input.checked = true; tr.classList.add('selected');
        
        // Remove error msg on successful selection
        const err = document.getElementById('saadaa-ksc-err');
        if(err) err.style.display = 'none';
      }
      tr.addEventListener('click', selectRow);
      input.addEventListener('change', selectRow);

      const currentId = variantInputMain && variantInputMain.value;
      if (vid && currentId && String(vid) === String(currentId)){ setTimeout(selectRow, 0); }

      tbody.appendChild(tr);
    });
    kscTable.appendChild(tbody);
    
    // Ensure table units respect current toggle state upon rendering
    updateTableUnits();
  }

  // Open modal on namespaced trigger
  document.addEventListener('click', async (e)=>{
    const btn = e.target.closest('.saadaa-ks-open-btn');
    if (!btn) return;
    let payload = readCache();                                   // local chart wins: no Kiwi, no 500ms wait
    if (!payload || !Object.keys(payload.rows||{}).length){
      payload = chooseBestPayload();
      if (!Object.keys(payload.rows).length){
        await ensureKiwiLoaded();
        payload = chooseBestPayload();
      }
      if (Object.keys(payload.rows).length) writeCache(payload);
    }
    rendersaadaaModal(payload);
    opensaadaaModal();
  });

  // Add to cart from modal with Validation and AJAX
  kscAddBtn.addEventListener('click', function(e){
    e.preventDefault();
    let choice = kscTable.querySelector('input[name="saadaaKscSize"]:checked');
    
    // If no size is checked, block adding and show warning
    if (!choice){
      let err = document.getElementById('saadaa-ksc-err');
      if (err) {
        err.style.display = 'block';
        err.animate([
          { transform: 'translateX(-4px)' },
          { transform: 'translateX(4px)' },
          { transform: 'translateX(-4px)' },
          { transform: 'translateX(4px)' },
          { transform: 'translateX(0)' }
        ], { duration: 300 });
      }
      return;
    }
    
    // Clear error
    const err = document.getElementById('saadaa-ksc-err');
    if (err) err.style.display = 'none';

    const size = choice.value;
    const vid = (psoConfig.variants || []).find(v => (v.option1||'').toUpperCase() === size)?.id;
    if (!vid) return;

    // Trigger GoKwik Drawer using AJAX helper
    window.saadaaAjaxAddToCart(vid, kscAddBtn, closesaadaaModal);
  });
})();

})();
